// If the target or any of its parents meet the condition, return the found item.
export function findEventTargetData(
  target: HTMLElement,
  condition: (target: HTMLElement) => boolean,
): HTMLElement | null {
  if (condition(target)) return target;
  if (!target.parentElement) return null;
  return findEventTargetData(target.parentElement, condition);
}
